export default __webpack_public_path__ + "static/media/document-right.55ec26d4.svg";